import React from 'react';
import { SvgIcon } from '../../../../../base-components/SvgIcon';

export const PlusSvgIcon = () => (
    <SvgIcon size={16}>
        <path strokeLinecap="round" d="M.5 8.115h15M8.115 15.5V.5" />
    </SvgIcon>
);
